// Pure game constants and derived dimensions.
// Extracted from GameCanvas.jsx — no runtime side-effects.
import { COLS } from "../../lib/levels";

export const W = 800;
export const H = 600;

export const BLOCK_PAD = 4;
export const GRID_TOP = 70;
export const GRID_LEFT = 40;
export const GRID_W = W - GRID_LEFT * 2;
export const BLOCK_W = GRID_W / COLS;
export const BLOCK_H = 28;

export const PADDLE_Y = H - 50;
export const BASE_PADDLE_W = 110;
export const PADDLE_H = 16;
export const BALL_RADIUS = 11;

// Comet theme palette — bricks form a top-to-bottom vertical gradient
// (cyan → violet → magenta → gold). Tier 4 is the boss/heavy variant.
// Glow stops are lighter shades for the inner highlight.
export const TIER_COLORS = {
  1: "#3aa8ff",   // sky-cyan (top rows)
  2: "#9b51ff",   // violet (mid)
  3: "#ff3df0",   // magenta (lower mid)
  4: "#ffb648",   // gold (boss / bottom)
};
export const TIER_GLOW = {
  1: "#9be4ff",
  2: "#cf95ff",
  3: "#ff9af3",
  4: "#ffe49a",
};
export const TIER_HP = { 1: 1, 2: 2, 3: 3, 4: 5 };

export const POWERUPS = ["multi", "enlarge", "slow", "life", "warp", "hole", "stingray"];
export const POWERUP_WEIGHTS = {
  multi: 25,
  enlarge: 25,
  slow: 20,
  life: 8,
  warp: 12,
  hole: 10,
  // Blood-Red Stingrays — rare boss-killer. Three small translucent
  // manta-rays that home in on the nearest boss/Leviathan and tear
  // off chunks of HP. Weight = 5 (rarer than Extra Life).
  stingray: 5,
};
export const POWERUP_CHANCE = 0.22;

// Moonstone (Endless-mode-only): an opal crescent that drops from destroyed
// blocks. Pilots collect them — wallet persists across runs (capped server-
// side). The mid-run shop power-ups (phase ball / time dilation / plasma /
// star shield) were removed on 2026-05-30 per user feedback. Internal
// references kept in `_MOONSTONE_POWERUP_DEFS` so the Endless wave-5 Plasma
// Boost milestone still resolves its duration constant.
export const MOONSTONE_DROP_CHANCE = 0.12;
export const MOONSTONE_FALL_SPEED = 1.6;
export const MOONSTONE_RADIUS = 11;

// Internal-only power-up defs — still used by the Endless wave-5 boosted
// plasma milestone for its default duration. NOT shown in the pause shop.
export const MOONSTONE_POWERUP_DEFS = {
  plasma: { duration: 8000 },
};

// Shop catalog rendered in the pause overlay. Empty by design — see
// the comment above. Leave the export so existing imports don't break;
// PauseOverlay early-returns when this is empty.
export const MOONSTONE_SHOP = {};
